import { useMemo } from "react"
import { useSearchParams, Outlet } from "react-router-dom"
import { Provider as UrqlProvider, Client, cacheExchange, fetchExchange } from "urql"
import { ThemeProvider } from "@/components/theme-provider"
import { Toaster } from "@/components/ui/sonner"

function createShareClient(token: string): Client {
  return new Client({
    url: "/graphql",
    requestPolicy: "cache-and-network",
    exchanges: [cacheExchange, fetchExchange],
    fetchOptions: () => ({
      headers: { Authorization: `Bearer ${token}` },
    }),
  })
}

export function ShareLayout() {
  const [params] = useSearchParams()
  const token = params.get("token") ?? ""

  const client = useMemo(() => createShareClient(token), [token])

  if (!token) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-muted-foreground">Invalid share link</p>
      </div>
    )
  }

  return (
    <UrqlProvider value={client}>
      <ThemeProvider>
        <div className="min-h-screen bg-background">
          <div className="mx-auto max-w-5xl px-4 py-8">
            <div className="mb-6 flex items-center gap-2 text-sm text-muted-foreground">
              <span className="font-semibold text-foreground">Hivehook</span>
              <span>Shared View</span>
            </div>
            <Outlet />
          </div>
        </div>
        <Toaster />
      </ThemeProvider>
    </UrqlProvider>
  )
}
